import { Component,ViewChild,OnInit } from '@angular/core';
import { BsModalComponent, BsModalService } from 'ng2-bs3-modal';
import { ObservableObjectsService } from '@services/http/observable-objects.service';
import { ObservableObject } from '@models/observable-object';
import { CachedDataService, AppService } from '@services';

@Component({
    selector:'select-object-modal',
    templateUrl:'./select-object-modal.component.html'
})

export class selectObjectComponent implements OnInit{
    @ViewChild('selectObjectModal')
    selectObjectModal: BsModalComponent;
    observableObjects: ObservableObject[];
    disabledClose:boolean = false;
    backdrop: string | boolean = true;
    constructor(
        private modalservice: BsModalService,
        private observableObjectsService: ObservableObjectsService,
        private cachedDataService: CachedDataService,
        private appService: AppService) {
       
        }
    ngOnInit() {
        this.getObject()
        this.observableObjects = this.cachedDataService.getObservableObjects(); ;
    }
    getObject(){
        this.observableObjectsService.getAll().subscribe(response => {
            this.observableObjects = this.appService.filterObjects(response);
            this.cachedDataService.setObservableObjects(this.observableObjects);
        }, error => console.log('from component error', error));
    }
   

    getObjectType(extra:string){
        return this.observableObjectsService.getObjectType(extra);
    }
    open(disabled?,objectId?){
        if(disabled){
            this.disabledClose = true;
            this.backdrop = "static";
        }else{
            this.disabledClose = false;
            this.backdrop = true;
        }
        if(objectId){
            this.observableObjects = this.observableObjects.filter(object => object.id == this.cachedDataService.getCurrentObject().id)
        }else{
            let objects = this.cachedDataService.getObservableObjects();

            objects.map(object=>{
                if(object.devices.length>1){
                   object.devices = this.sortArrayDown(object.devices)
                }
            })
            this.observableObjects = objects;
        }

     
 
        this.selectObjectModal.open();
    }
    close(){
        this.selectObjectModal.close();
    }

    sortArrayDown(array){
		return array.sort((obj1, obj2) => {
			if (obj1.created > obj2.created) {
				return 1;
			}
		
			if (obj1.created < obj2.created) {
				return -1;
			}
		
			return 0;
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/view/modal/select-object-modal/select-object-modal.component.ts